import React from 'react';

export default function FieldGroup({ label, children, full }) {
  return (
    <div className={`field-group${full ? ' full' : ''}`}>
      <label className="field-label">{label}</label>
      {children}
    </div>
  );
}
